export default {
  title: 'My Vehicles',
  no_vehicles: 'No vehicles registered',
  no_vehicles_sub: 'Your registered vehicles will appear here.',
  vehicle_types: {
    car: 'Car',
    motorcycle: 'Motorcycle',
    bicycle: 'Bicycle',
    other: 'Other',
  },
  labels: {
    license_plate: 'License Plate',
    brand_model: 'Brand / Model',
    color: 'Color',
    active_permits: 'Active Permits',
    no_active_permits: 'No active parking permits',
    permit_type: 'Type',
    zone: 'Zone',
    slot: 'Slot',
    sticker: 'Sticker',
    valid_until: 'Valid Until',
    monthly_fee: 'Monthly Fee',
    daily_fee: 'Daily Fee',
    last_seen: 'Last Seen',
  },
  permit_types: {
    tenant_included: 'Included',
    tenant_addon: 'Add-on',
    monthly_external: 'Monthly',
    daily_external: 'Daily',
  },
  lpr: {
    recent_events_title: 'Recent LPR Events',
    show_events: 'Show Events',
    hide_events: 'Hide Events',
    n_more: '{{count}} more',
    view_all: 'View All Events',
    direction_in: 'In',
    direction_out: 'Out',
    direction_unknown: 'Unknown',
    no_events: 'No recent camera events',
    status: {
      verified_success: 'Verified',
      verified_failed: 'Not matched',
      pending: 'Pending',
    },
  },
}
